<template>
  <div
    v-loading="store.procesando"
    class="cotizacion-masiva"
    element-loading-text="Procesando lote… el cálculo masivo puede demorar unos minutos. No cierres esta pantalla."
    element-loading-background="rgba(255, 255, 255, 0.85)"
  >
    <p class="cotizacion-masiva__help">
      Descargá la plantilla, completala y subila para validar las filas antes de la carga
      definitiva. La validación no crea cotizaciones: se generan recién al procesar el lote.
    </p>
    <masiva-template-upload />
    <template v-if="store.hayResultado">
      <masiva-summary />
      <masiva-process-actions />
      <masiva-result-table />
    </template>
    <masiva-decision-dialog />
  </div>
</template>

<script setup>
import { onBeforeUnmount } from 'vue';
import { vLoading } from 'element-plus';
import MasivaTemplateUpload from './components/masiva_template_upload.vue';
import MasivaSummary from './components/masiva_summary.vue';
import MasivaProcessActions from './components/masiva_process_actions.vue';
import MasivaResultTable from './components/masiva_result_table.vue';
import MasivaDecisionDialog from './components/masiva_decision_dialog.vue';
import { useCotizacionMasivaStore } from './stores/cotizacion_masiva_store.js';

const store = useCotizacionMasivaStore();

onBeforeUnmount(() => store.reset());
</script>

<style scoped>
.cotizacion-masiva {
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-height: 200px;
}

.cotizacion-masiva__help {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
}
</style>
